
import React from 'react'
import { RatingStars } from './RatingStars'
import { BackButton } from './BackButton'
import { NextButton } from './NextButton'
import { isMobile } from 'react-device-detect'
import { Grid } from '@material-ui/core'

export const FloatingFooterAction = (props) => {
  return (
    isMobile && (
    <Grid container lg={10} style={{ padding: '1rem' }} className='justify-between'>
      <BackButton />
      <RatingStars />
      <NextButton />
    </Grid>
    )
  )
}